<!--
  Kommerzielle Landingpage „Hofladen-Automat kaufen“. Muster identisch zur
  Eierautomat-Seite (Design-System-Klassen + hla-*). Animationen via .reveal
  (initFeatureFx). Fokus auf Shop; Ratgeber-Link bewusst sekundär.
  Kleine Spielerei: wachsendes Pflänzchen (reine CSS/SVG) im Hero.
-->
<section class="hla-hero">
  <div class="content content--wide hla-hero__grid">
    <div class="hla-hero__text reveal">
      <!-- Wachsendes Pflänzchen (reine CSS/SVG, reduced-motion-sicher).
           Sonne = Marken-Orange (--color-secondary). Dekorativ → aria-hidden. -->
      <div class="hla-sprout" aria-hidden="true">
        <svg viewBox="0 0 100 100" role="img">
          <g class="hla-sprout__sun">
            <circle cx="78" cy="24" r="9" class="hla-sprout__sun-core" />
            <g class="hla-sprout__rays">
              <line x1="78" y1="6" x2="78" y2="12" />
              <line x1="78" y1="36" x2="78" y2="42" />
              <line x1="60" y1="24" x2="66" y2="24" />
              <line x1="90" y1="24" x2="96" y2="24" />
              <line x1="65" y1="11" x2="69" y2="15" />
              <line x1="87" y1="33" x2="91" y2="37" />
              <line x1="65" y1="37" x2="69" y2="33" />
              <line x1="87" y1="15" x2="91" y2="11" />
            </g>
          </g>
          <path class="hla-sprout__soil" d="M14,82 Q50,76 86,82" />
          <g class="hla-sprout__plant">
            <path class="hla-sprout__stem" pathLength="100" d="M50,82 C50,70 49,62 50,50" />
            <path class="hla-sprout__leaf hla-sprout__leaf--l" d="M50,60 C40,55 33,60 40,66 C46,66 50,63 50,60 Z" />
            <path class="hla-sprout__leaf hla-sprout__leaf--r" d="M50,55 C60,50 67,55 60,61 C54,61 50,58 50,55 Z" />
          </g>
        </svg>
      </div>
      <span class="hla-eyebrow" i18n="@@hla.hero.eyebrow">Direktvermarktung · 24/7</span>
      <h1 class="title display" i18n="@@hla.hero.h1">Hofladen-Automat kaufen</h1>
      <div class="line"></div>
      <p class="hla-lead" i18n="@@hla.hero.lead">
        Verkaufe deine Hofprodukte rund um die Uhr – ohne feste Öffnungszeiten und mit spürbar entlastetem Personal.
        Die <span class="tm">marktbox</span> ist dein Hofladen-Automat für die regionale Direktvermarktung:
        bargeldlos, app-gesteuert und wetterfest im Einsatz.
      </p>
      <div class="hla-cta">
        <a class="btn btn-primary hla-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@hla.hero.ctaShop">Modelle &amp; Preise im Shop</a>
        <a class="hla-cta__ghost" href="#preise" (click)="scrollTo($event, 'preise')" i18n="@@hla.hero.ctaAnchor">Kaufen oder mieten? ↓</a>
      </div>
    </div>
    <figure class="hla-hero__media reveal">
      <img src="assets/headers/marktbox-01-1440.webp"
        alt="marktbox Hofladen-Automat für die regionale Direktvermarktung" i18n-alt="@@hla.hero.imgAlt"
        width="1440" height="960" fetchpriority="high" />
      <span class="hla-hero__badge" i18n="@@hla.hero.badge">🌱 frisch vom Hof</span>
    </figure>
  </div>
</section>

<!-- ===== Vorteile ===== -->
<section class="hla-section">
  <div class="content content--wide">
    <h2 class="hla-h2 reveal" i18n="@@hla.adv.h2">Warum die marktbox als Hofladen-Automat?</h2>
    <div class="hla-grid">
      <div class="hla-card reveal">
        <span class="hla-card__ico">🕒</span>
        <h3 i18n="@@hla.adv1.h3">24/7 Hofverkauf</h3>
        <p i18n="@@hla.adv1.p">Deine Kundschaft kauft frische Hofprodukte, wann sie will – auch abends, sonntags und feiertags.</p>
      </div>
      <div class="hla-card reveal">
        <span class="hla-card__ico">💳</span>
        <h3 i18n="@@hla.adv2.h3">Bargeldlos &amp; app-gesteuert</h3>
        <p i18n="@@hla.adv2.p">Kartenzahlung am Automaten, Fernwartung und Füllstände per App – ohne täglichen Aufwand vor Ort.</p>
      </div>
      <div class="hla-card reveal">
        <span class="hla-card__ico">🧺</span>
        <h3 i18n="@@hla.adv3.h3">Viele Hofprodukte</h3>
        <p i18n="@@hla.adv3.p">Eier, Kartoffeln, Spargel, Obst &amp; Beeren, Backwaren, Honig oder Wein – lagerfähige Hofprodukte rund um die Uhr.</p>
      </div>
      <div class="hla-card reveal">
        <span class="hla-card__ico">🚜</span>
        <h3 i18n="@@hla.adv4.h3">Direkt ab Hof</h3>
        <p i18n="@@hla.adv4.p">Verkaufe ohne Zwischenhandel – mit voller Kontrolle über Preis, Auswahl und Präsentation.</p>
      </div>
    </div>
  </div>
</section>

<!-- ===== Live-Link (Killer-Feature) ===== -->
<section class="hla-section hla-live">
  <div class="content content--wide hla-live__grid">
    <div class="hla-live__text reveal">
      <span class="hla-eyebrow" i18n="@@hla.live.eyebrow">Live-Link · Echtzeit</span>
      <h2 class="hla-h2" i18n="@@hla.live.h2">Sieh, was gerade in der Box ist</h2>
      <p class="hla-lead" i18n="@@hla.live.lead">
        Jede marktbox hat ihren eigenen Live-Link: Deine Kundschaft sieht in Echtzeit, welche
        Hofprodukte gerade verfügbar sind – noch bevor sie losfährt. Das schafft Vertrauen,
        spart unnötige Wege und bringt mehr Verkäufe.
      </p>
      <ul class="hla-live__list">
        <li i18n="@@hla.live.li1">Echtzeit-Verfügbarkeit, rund um die Uhr</li>
        <li i18n="@@hla.live.li2">Teilbar per Link, QR-Code &amp; auf der eigenen Website</li>
        <li i18n="@@hla.live.li3">Ohne App – einfach im Browser</li>
      </ul>
      <div class="hla-cta">
        <a class="btn btn-primary hla-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@hla.live.cta">Automat mit Live-Link sichern</a>
      </div>
    </div>
    <div class="lp-phonecol reveal">
      <div class="lp-phone">
        <div class="lp-phone__island" aria-hidden="true"></div>
        <div class="lp-phone__screen">
          <iframe [src]="liveUrl"
            title="marktbox Live-Link – Obsthof Zink: Echtzeit-Verfügbarkeit der Box" i18n-title="@@hla.live.iframeTitle"
            loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          <div class="lp-phone__hint" aria-hidden="true"><span class="lp-phone__chev"></span> <ng-container i18n="@@lp.phone.scroll">scrollen</ng-container></div>
          <div class="lp-phone__home" aria-hidden="true"></div>
        </div>
        <div class="lp-phone__corners" aria-hidden="true"></div>
      </div>
      <p class="lp-phone__cap"><span class="lp-live__dot"></span> <ng-container i18n="@@hla.live.cap">Live-Beispiel: Obsthof Zink</ng-container></p>
    </div>
  </div>
</section>

<!-- ===== Preise / Kaufen oder mieten ===== -->
<section id="preise" class="hla-section hla-section--muted">
  <div class="content content--wide">
    <h2 class="hla-h2 reveal" i18n="@@hla.price.h2">Hofladen-Automat kaufen oder mieten</h2>
    <div class="hla-price-grid">
      <div class="hla-price reveal">
        <span class="hla-price__label" i18n="@@hla.price.buyLabel">Kaufen</span>
        <span class="hla-price__value">ab {{ priceBuyFrom | number : '1.0-0' }} €</span>
        <p i18n="@@hla.price.buyText">Einmalige Investition, dauerhaft dein Automat – ideal für den langfristigen Betrieb.</p>
      </div>
      <div class="hla-price reveal">
        <span class="hla-price__label" i18n="@@hla.price.rentLabel">Mieten</span>
        <span class="hla-price__value">ab {{ priceRentFrom }} € / Monat</span>
        <p i18n="@@hla.price.rentText">Niedrige Einstiegshürde, planbare monatliche Kosten – ideal zum Starten und Testen.</p>
      </div>
    </div>
    <div class="hla-cta hla-cta--center reveal">
      <a class="btn btn-primary hla-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@hla.price.cta">Zum Shop – Hofladen-Automat konfigurieren</a>
    </div>
    <p class="hla-fineprint reveal" i18n="@@hla.price.fine">
      Noch unsicher?
      <a [routerLink]="['/', links.blog, blogHofladen]">Im Ratgeber: Einen Hofladen-Automaten aufstellen</a>
    </p>
  </div>
</section>

<!-- ===== Modelle ===== -->
<section class="hla-section">
  <div class="content content--wide">
    <h2 class="hla-h2 reveal" i18n="@@hla.mod.h2">Passende Modelle</h2>
    <div class="hla-models">
      <a class="hla-model reveal" [routerLink]="['/', links.shop, 'marktbox-39']">
        <figure class="hla-model__media">
          <img src="assets/rendered/39/webp/frame-0035.webp" alt="marktbox 39 – Hofladen-Automat mit 39 Fächern" i18n-alt="@@hla.mod39.alt"
            width="800" height="800" loading="lazy" />
        </figure>
        <div class="hla-model__body">
          <h3>marktbox 39</h3>
          <p i18n="@@hla.mod39.text">39 Fächer – für ein breites Sortiment und höhere Stückzahlen.</p>
          <span class="hla-model__more" i18n="@@hla.mod39.more">Modell ansehen →</span>
        </div>
      </a>
      <a class="hla-model reveal" [routerLink]="['/', links.shop, 'marktbox-24']">
        <figure class="hla-model__media">
          <img src="assets/rendered/24/webp/frame-0035.webp" alt="marktbox 24 – kompakter Hofladen-Automat mit 24 Fächern" i18n-alt="@@hla.mod24.alt"
            width="800" height="800" loading="lazy" />
        </figure>
        <div class="hla-model__body">
          <h3>marktbox 24</h3>
          <p i18n="@@hla.mod24.text">24 Fächer – kompakter Einstieg für die Direktvermarktung ab Hof.</p>
          <span class="hla-model__more" i18n="@@hla.mod24.more">Modell ansehen →</span>
        </div>
      </a>
    </div>
  </div>
</section>

<!-- ===== Praxis-Band (Direktvermarkter) ===== -->
<section class="hla-band reveal">
  <div class="content content--wide hla-band__grid">
    <figure class="hla-band__media">
      <img src="assets/slides/testimonial-01.webp" alt="Direktvermarkter verkauft regionale Hofprodukte über die marktbox" i18n-alt="@@hla.band.imgAlt"
        width="1200" height="800" loading="lazy" />
    </figure>
    <div class="hla-band__text">
      <h2 class="hla-h2" i18n="@@hla.band.h2">Dein Hofladen – rund um die Uhr geöffnet</h2>
      <p i18n="@@hla.band.p">
        Ob Eier, Kartoffeln, Backwaren oder Honig: Mit der marktbox verkaufst du deine Hofprodukte regional,
        rund um die Uhr und ohne Personal vor Ort. Finde im Shop das passende Modell und starte in wenigen Schritten.
      </p>
      <a class="btn btn-primary" [routerLink]="['/', links.shop]" i18n="@@hla.band.cta">Jetzt Modelle vergleichen</a>
    </div>
  </div>
</section>

<!-- ===== FAQ ===== -->
<section class="hla-section hla-section--muted">
  <div class="content content--wide">
    <h2 class="hla-h2 reveal" i18n="@@hla.faq.h2">Häufige Fragen zum Hofladen-Automat</h2>
    <div class="hla-faq reveal">
      @for (f of faqs; track f.q) {
      <details class="hla-faq__item">
        <summary>{{ f.q }}</summary>
        <p>{{ f.a }}</p>
      </details>
      }
    </div>
    <p class="hla-fineprint reveal" i18n="@@hla.faq.fine">
      Mehr Praxiswissen im Ratgeber:
      <a [routerLink]="['/', links.blog, blogHofladen]">Einen Hofladen-Automaten aufstellen</a>.
    </p>
  </div>
</section>

<!-- ===== Abschluss-CTA ===== -->
<section class="hla-section hla-final reveal">
  <div class="content content--wide">
    <h2 class="hla-h2" i18n="@@hla.final.h2">Bereit für deinen Hofladen-Automaten?</h2>
    <p class="hla-lead" i18n="@@hla.final.lead">Finde dein Modell, wähle kaufen oder mieten und starte in die Direktvermarktung.</p>
    <div class="hla-cta hla-cta--center">
      <a class="btn btn-primary hla-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@hla.final.cta">Jetzt Modelle &amp; Preise ansehen</a>
    </div>
  </div>
</section>
